(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vivazz-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vivazz-size-guide')) {
    customElements.define('vivazz-size-guide', class extends HTMLElement {
      static preferredUnit = 'cm';
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.setUnit(this.constructor.preferredUnit);
        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const dialog = this.querySelector('dialog');
          if (event.target.closest('[data-size-guide-open]')) {
            event.preventDefault();
            this.setUnit(this.constructor.preferredUnit);
            dialog.showModal();
            return;
          }
          if (event.target.closest('[data-size-guide-close]')) {
            dialog.close();
            return;
          }
          if (event.target === dialog) {
            const bounds = dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
            return;
          }
          const button = event.target.closest('[data-size-unit-button]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          event.stopPropagation();
          const unit = button.dataset.sizeUnitButton;
          this.constructor.preferredUnit = unit;
          document.querySelectorAll('vivazz-size-guide').forEach((guide) => guide.setUnit(unit));
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.querySelector('dialog[open]')?.close(); this.controller?.abort(); }
      setUnit(unit) {
        this.dataset.unit = unit === 'in' ? 'in' : 'cm';
        this.querySelectorAll('[data-size-unit-button]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.sizeUnitButton === this.dataset.unit));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
